var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIyzico({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184,
    height: 80,
    viewBox: "0 0 184 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "uwtj7m37aa",
    d: "M0 0.07L10.176 0.07 10.176 10.188 0 10.188z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gm7ejcreqc",
    d: "M0.215 0.07L10.398 0.07 10.398 10.188 0.215 10.188z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E64FF",
    d: "M5.087 14.81C2.543 14.81.48 16.86.48 19.382v26.773c0 2.531 2.062 4.576 4.606 4.576 2.542 0 4.605-2.045 4.605-4.576V19.382c0-2.523-2.063-4.572-4.605-4.572",
    transform: "translate(0 .914)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .914) translate(0 .162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6r16igxdyb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uwtj7m37aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E64FF",
    d: "M5.087.07C2.277.07 0 2.335 0 5.13c0 2.789 2.278 5.058 5.087 5.058 2.808 0 5.089-2.27 5.089-5.058 0-2.795-2.281-5.06-5.09-5.06",
    mask: "url(#6r16igxdyb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E64FF",
    d: "M87.526 46.155c0-2.524-2.064-4.58-4.611-4.58H70.194l16.258-19.25c1.631-1.935 1.377-4.827-.57-6.444-.907-.76-2.018-1.109-3.119-1.071-.051-.006-20.343 0-20.343 0-2.546 0-4.606 2.05-4.606 4.571 0 2.531 2.06 4.587 4.606 4.587h10.626L56.792 43.213c-1.637 1.94-1.38 4.825.566 6.446.863.726 1.916 1.072 2.962 1.072h22.595c2.547 0 4.611-2.045 4.611-4.576M128.12 23.358c2.523 0 4.887.972 6.672 2.748 1.798 1.783 4.715 1.783 6.516 0 1.792-1.79 1.792-4.688 0-6.476-3.524-3.504-8.208-5.431-13.189-5.431-4.975 0-9.657 1.927-13.177 5.43-3.522 3.503-5.463 8.15-5.463 13.102 0 4.948 1.94 9.605 5.463 13.098 3.52 3.503 8.202 5.435 13.177 5.435 4.981 0 9.665-1.932 13.19-5.435 1.791-1.781 1.791-4.68 0-6.468-1.802-1.792-4.72-1.792-6.517 0-1.785 1.764-4.149 2.75-6.673 2.75-2.517 0-4.885-.986-6.664-2.75-1.783-1.773-2.763-4.126-2.763-6.63 0-2.504.98-4.862 2.763-6.625 1.78-1.776 4.147-2.748 6.664-2.748M165.356 42.111c-5.197 0-9.424-4.21-9.424-9.38 0-5.17 4.227-9.373 9.424-9.373 5.202 0 9.435 4.203 9.435 9.373 0 5.17-4.233 9.38-9.435 9.38m0-27.912c-10.275 0-18.638 8.313-18.638 18.532 0 10.218 8.363 18.533 18.638 18.533 10.28 0 18.644-8.315 18.644-18.533 0-10.22-8.363-18.532-18.644-18.532M98.839 14.81c-2.54 0-4.6 2.05-4.6 4.572v26.773c0 2.531 2.06 4.576 4.6 4.576 2.548 0 4.606-2.045 4.606-4.576V19.382c0-2.523-2.058-4.572-4.606-4.572",
    transform: "translate(0 .914)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .914) translate(93.533 .162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "63pm8sc9gd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gm7ejcreqc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E64FF",
    d: "M5.305.07C2.495.07.215 2.335.215 5.13c0 2.789 2.28 5.058 5.09 5.058 2.815 0 5.093-2.27 5.093-5.058 0-2.795-2.278-5.06-5.093-5.06",
    mask: "url(#63pm8sc9gd)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E64FF",
    d: "M49.812 15.325c-2.259-1.167-5.037-.293-6.21 1.948l-9.879 18.93-9.88-18.93c-1.17-2.24-3.953-3.115-6.21-1.948-2.255 1.169-3.136 3.933-1.963 6.178l12.861 24.644-5.938 11.4c-1.174 2.245-.299 5.01 1.96 6.174.741.39 1.54.55 2.322.512 1.59-.066 3.105-.951 3.895-2.457l21-40.273c1.177-2.245.3-5.01-1.958-6.178",
    transform: "translate(0 .914)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIyzico);
export default __webpack_public_path__ + "static/media/iyzico.044d47993120a1180d6e9f17fc6f414a.svg";
export { ForwardRef as ReactComponent };